<template>
  <div id="tree-panel">
    <div class="panel-title">
      Tree
      <user-select :model="treePanel" prop="selectedUser" :add-all-option="false"></user-select>
    </div>
    <tree-panel-filter></tree-panel-filter>
    <spinner :show="loading"></spinner>
    <!-- Subtree Filter -->
    <div class="subtree-filter" v-if="subtreeFilter">
      <infobit :infobit="subtree.infobit"></infobit>
      <button class="clickable" @click="resetSubtreeFilter">Reset</button>
    </div>
    <!-- Tree -->
    <infobits-tree v-if="subtree" :tree="subtree"></infobits-tree>
    <!-- Empty Tree Drop Area -->
    <div class="empty-tree-drop-area" v-if="isTreeEmpty" v-dragula="[]" bag="infobits">
      Drop infobits from the inbox here
    </div>
  </div>
</template>

<script>
export default {

  computed: {

    treePanel () {
      return this.$store.state.treePanel
    },

    tree () {
      return this.treePanel.tree
    },

    isTreeEmpty () {
      return this.tree && this.tree.nodes.length === 0
    },

    subtree () {
      return this.treePanel.subtree
    },

    subtreeFilter () {
      return this.subtree !== this.tree
    },

    loading () {
      return this.treePanel.loading
    }
  },

  methods: {
    resetSubtreeFilter () {
      this.$store.dispatch('resetSubtreeFilter')
    }
  },

  components: {
    'user-select':       require('./user-select.vue'),
    'infobits-tree':     require('./infobits-tree.vue'),
    'infobit':           require('./infobit.vue'),
    'spinner':           require('./spinner.vue'),
    'tree-panel-filter': require('./tree-panel-filter.vue')
  }
}
</script>

<style>
#tree-panel {
  width: 40%;
  flex-grow: 1;
  overflow-y: scroll;
  resize: horizontal;
  box-sizing: border-box;
  background-color: var(--tree-panel-color);
  padding-left:  var(--horizontal-panel-padding);
  padding-right: var(--horizontal-panel-padding);
}

#tree-panel .panel-title .user-select {
  margin-left: 1em;
}

#tree-panel .tree-panel-filter {
  margin-bottom: 2em;
}

#tree-panel .subtree-filter {
  display: flex;
  align-items: center;
  border-top: 1px dotted gray;
  border-bottom: 1px dotted gray;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
}

#tree-panel .subtree-filter .infobit {
  flex: auto;
  min-width: 0;     /* make word-wrap effective in a flex layout */
}

#tree-panel .subtree-filter button {
  flex: none;
  visibility: hidden;
}

#tree-panel .subtree-filter:hover button {
  visibility: visible;
}

#tree-panel .empty-tree-drop-area {
  border: 1px dotted #c7c7c7;
  font-size: var(--small-font-size);
  color: gray;
  width: 75%;
  height: 4em;
  padding: 0.5em;
}
</style>



// WEBPACK FOOTER //
// tree-panel.vue?30734246